import React from 'react';
import {
  usePlateEditorRef,
  useEventPlateId,
  getPluginType,
  someNode,
  getListItemEntry,
  unwrapList,
  toggleNodeType,
  focusEditor,
  ELEMENT_DEFAULT,
  ELEMENT_TODO_LI,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ToolbarButton } from './ToolbarButton';
import { getTodoListItemEntry } from '../../plugins/todo-list/getTodoListItemEntry';

export const TodoListButton = ({ ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId());

  const res = !!editor?.selection && getTodoListItemEntry(editor);

  return (
    <ToolbarButton
      name="Insert checklist"
      active={!!res && res.listItem[0].type === ELEMENT_TODO_LI}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleTodoList(editor, { activeType: getPluginType(editor, ELEMENT_TODO_LI) });
      }}
      icon={<FontAwesomeIcon icon={['fa', 'check-square']} />}
      {...props}
    />
  );
};

export const toggleTodoList = (editor, options) => {
  const {
    activeType,
    inactiveType = getPluginType(editor, ELEMENT_DEFAULT),
  } = options;

  if (!activeType || !editor.selection) return;

  const isActive = someNode(editor, {
    match: {
      type: activeType,
    },
  });

  if (isActive && activeType === inactiveType) return;

  const listRes = getListItemEntry(editor, {});

  if (listRes) {
    unwrapList(editor);
  }

  toggleNodeType(editor, { activeType, inactiveType });
  focusEditor(editor);
};
